import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(1.5),
        borderBottom: '1px solid #e0e0e0',
    },
    image: {
        width: 60,
        height: 60,
        backgroundSize: 'contain',
        marginBottom: theme.spacing(0.5),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    circleImage: {
        borderRadius: '50%'
    },
    messageWrapper: {
        paddingLeft: theme.spacing(2) + 'px!important',
    },
    greyText: {
        fontSize: '0.8rem',
        color: 'grey',
    },
    systemMessage: {
        fontWeight: 500,
        color: theme.palette.primary[500],
        display: 'inline',
        marginLeft: theme.spacing(1),
    },
    message: {
        fontWeight: 500,
        fontSize: '0.9rem',
    }
});


class Message extends PureComponent {

    render() {
        const {classes, sender, message} = this.props;

        return (
            <Grid container className={classes.root} spacing={1}>
                <Grid item>
                    <div className={classes.image + ' ' + (sender.makeCircle ? classes.circleImage : null)}
                         style={{backgroundImage: 'url(' + sender.img + ')'}}></div>
                    <Typography align={'center'} className={classes.greyText}>
                        {sender.name}
                    </Typography>
                </Grid>
                <Grid item className={classes.messageWrapper} xs>
                    <Typography variant="caption" className={classes.greyText} style={{width: '100%', marginBottom: 4}}>
                        {message.timestamp}
                        {message.isSystemMessage &&
                        <div className={classes.systemMessage}>Automaattiviesti</div>
                        }
                    </Typography>
                    <Typography variant="body1" className={classes.message}>
                        {message.text}
                    </Typography>
                </Grid>
            </Grid>
        )
    }
}


export default withStyles(styles)(Message);
